import { gql } from '@apollo/client';

export const UPSERT_ECD_REGISTRATION = gql`
  mutation UpsertECDRegistration($input: UpsertECDRegistrationInput!) {
    ecdRegistration: upsertEcdRegistration(input: $input) {
      id

      afterCareComments
      applicationCollectionType
      applicationNotes
      applicationSubmissionType
      approvalStatus
      reasonForFlagging
      approved
      approvedBy {
        id
        firstName
        lastName
      }
      assessEcdFrameworkOnline
      assessmentNotes
      assignee {
        id
        firstName
        lastName
      }
      associatedEcdInstitution {
        id
        districtMunicipality {
          id
          name
        }
        name
        numberOfChildrenEnrolled
        physicalAddress
        postalAddress
        postalCode
        province {
          id
          name
        }
        socialServicesProfessional {
          id
          firstName
          lastName
        }
        sspSupervisor {
          id
          firstName
          lastName
        }
        identifiedBy
        identifiedDate
      }
      certificateNumber
      dateAssigned
      dateAttended
      dateCertificateReceivedFromDistrict
      dateCollected
      dateEHPReportReceived
      dateCertificateDispensed
      dateFileCompilationSubmitted
      dateIdentified
      dateInvited
      dateOfDSDSiteVisit
      dateOfEHPSiteVisit
      dateProgCertificateReceivedFromDistrict
      dateProgCertificateDispensed
      dateSubmissionCompleted
      dateSubmitted
      expiryDate
      frameworkAnswers {
        id
        question {
          id
          title
          name
          tag
        }
        answer
        files {
          id
          name
          url
        }
      }
      generalSafetyComments
      identifiedBy
      issueDate
      modifiedBy {
        id
        firstName
        lastName
      }
      newOrRenewal
      numberOfChildrenPresent
      numberOfStaffPresent
      otherAssessmentDelayReasons
      pcrLevel
      progCertificateExpiryDate
      progCertificateIssueDate
      progCertificateNumber
      progLevel
      programmeAssessmentOutcome
      progRegistrationOutcome
      providedDocuments {
        id
        document {
          id
          name
        }
        provided
      }
      reasonForAssessmentDelay
      reasonForCertificationDelay
      reasonForProgCertificationDelay
      reasonForRejection
      progReasonForRejection
      reasonForWithdrawal
      registrationOutcome
      registrationType {
        id
        name
      }
      siteAssessmentOutcome
      submissionNumber
      submitted
      transportComments
    }
  }
`;
